'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

import { throttle } from 'lodash-es';

import { AffixMask, StyledAffix } from './AffixStyle';

export type AffixProps = {
  offsetTop?: string;
  onChange?: (affixed: boolean) => void;
};

const Affix = ({
  offsetTop,
  onChange,
  children,
}: React.PropsWithChildren<AffixProps>) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const height = useRef(0);
  const elementHeight = useRef(0);

  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!height.current) {
      height.current = ref.current?.offsetTop || 0;
      elementHeight.current = ref.current?.offsetHeight || 0;
    }
  }, [ref]);

  const handleScroll = useCallback(() => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    const nextState = scrollTop > height.current;
    setEnabled(nextState);
    onChange?.(nextState);
  }, [onChange]);

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 200), {
      passive: true,
    });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <>
      <AffixMask height={elementHeight.current} visible={enabled} />
      <StyledAffix offsetTop={offsetTop} ref={ref} affix={enabled}>
        {children}
      </StyledAffix>
    </>
  );
};

export default Affix;
